import React from "react";
import {Divider, Link} from "@nextui-org/react";
import {faEnvelope, faPhone} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {library} from "@fortawesome/fontawesome-svg-core";
import {faLinkedin} from "@fortawesome/free-brands-svg-icons";


const Footer = () => {
    library.add(faPhone, faEnvelope);
    return (
        <div>
            {/*<div className="grid grid-cols-12 grid-rows-1">*/}
            {/*    <div className="col-span-4 sm:col-span-4 grid grid-cols-1 gap-2">*/}
            {/*        <Card className="col-span-6 sm:col-span-12 bg-opacity-0" radius="none" shadow="none">*/}
            {/*            <CardBody className="justify-center items-start gap-2">*/}
            {/*                /!*<p className="text-tiny text-white/60 uppercase font-bold">Your day your way</p>*!/*/}
            {/*                <h2 className="text-medium text-white/90 uppercase font-bold">UBION</h2>*/}
            {/*                <h2 className="text-small">About Us</h2>*/}
            {/*                <h2 className="text-small">Press</h2>*/}
            {/*                <h2 className="text-small">Privacy</h2>*/}
            {/*                <h2 className="text-small">Imprint</h2>*/}
            {/*                /!*<h4 className="text-white/90 font-large text-2xl">Answers to some questions you might have.</h4>*!/*/}
            {/*            </CardBody>*/}
            {/*        </Card>*/}
            {/*    </div>*/}
            {/*    <div className="col-span-4 sm:col-span-4 grid grid-cols-1 gap-2">*/}
            {/*        <Card className="col-span-6 sm:col-span-12 bg-opacity-0" radius="none" shadow="none">*/}
            {/*            <CardBody className="justify-center items-start gap-2">*/}
            {/*                /!*<p className="text-tiny text-white/60 uppercase font-bold">Your day your way</p>*!/*/}
            {/*                <h2 className="text-medium text-white/90 uppercase font-bold">Explore</h2>*/}
            {/*                <h2 className="text-small">Products and services</h2>*/}
            {/*                <h2 className="text-small">Dashboard template</h2>*/}
            {/*                <h2 className="text-small">Docs</h2>*/}
            {/*                /!*<h4 className="text-white/90 font-large text-2xl">Answers to some questions you might have.</h4>*!/*/}
            {/*            </CardBody>*/}
            {/*        </Card>*/}
            {/*    </div>*/}
            {/*    <div className="col-span-4 sm:col-span-4 grid grid-cols-1 gap-2">*/}
            {/*        <Card className="col-span-6 sm:col-span-12 bg-opacity-0" radius="none" shadow="none">*/}
            {/*            <CardBody className="justify-center items-start gap-2">*/}
            {/*                /!*<p className="text-tiny text-white/60 uppercase font-bold">Your day your way</p>*!/*/}
            {/*                <h2 className="text-medium text-white/90 uppercase font-bold">Let's connect</h2>*/}
            {/*                <h2 className="text-small">Contact us</h2>*/}
            {/*                <h2 className="text-small">LinkedIn</h2>*/}
            {/*                /!*<h4 className="text-white/90 font-large text-2xl">Answers to some questions you might have.</h4>*!/*/}
            {/*            </CardBody>*/}
            {/*        </Card>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <Divider/>
            <div
                className="py-5 px-4 flex flex-col items-center justify-center space-y-2
                sm:flex-col
                md:flex-col
                lg:flex-row
                {/*lg:justify-between*/}
                {/*lg:items-start*/}
                lg:space-y-0
                lg:space-x-10 w-full">
                {/* Footer Item 1 */}
                <div className="text-center lg:text-left">
                    <h2 className="text-small">© 2025 ubion GmbH</h2>
                </div>

                {/* Footer Item 2 */}
                <div className="text-center lg:text-left">
                    <h2 className="text-small">Uhdestraße 25, 08056 Zwickau</h2>
                </div>

                {/* Footer Item 3 */}
                <div className="text-center lg:text-left flex flex-col lg:flex-row items-center lg:items-start">
                    <FontAwesomeIcon icon="fa-phone" className="mr-2"/>
                    <a
                        className="text-small underline"
                        href="tel:+4935727219770"
                    >
                        +4935727219770
                    </a>
                </div>

                {/* Footer Item 4 */}
                <div className="text-center lg:text-left flex flex-col lg:flex-row items-center lg:items-start">
                    <FontAwesomeIcon icon="fa-envelope" className="mr-2"/>
                    <a
                        className="text-small underline"
                        href="mailto:info@ubi-on.com?subject=Kontaktanfrage"
                    >
                        info@ubi-on.com
                    </a>
                </div>
                <div className="text-center lg:text-left flex flex-col lg:flex-row items-center lg:items-start">
                    <a
                        href="https://www.linkedin.com/company/ubi-on"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-center lg:text-left"
                        style={{textDecoration: "none", color: "inherit"}}
                    >
                        <FontAwesomeIcon icon={faLinkedin} size="2x" style={{color: "#0077B5"}}/>
                    </a>
                </div>


                {/* Footer Item 6 */}
                <Link
                    color="foreground"
                    underline={"always"}
                    href="/impressum"
                    className="text-center lg:text-left"
                >
                    <h2 className="text-small">Impressum</h2>
                </Link>

                {/* Footer Item 7 */}
                <Link
                    color="foreground"
                    underline={"always"}
                    href="/datenschutz"
                    className="text-center lg:text-left"
                >
                    <h2 className="text-small">Datenschutzerklärung</h2>
                </Link>
            </div>
        </div>
    )
}
export default Footer;
